import axios from 'axios'
import $axios from '../../axios'
import _each from 'lodash/each'
import _uniq from 'lodash/uniq'
import _map from 'lodash/map'
import _countBy from 'lodash/countBy'
import _filter from 'lodash/filter'
import _some from 'lodash/some'
import _includes from 'lodash/includes'
import _orderBy from 'lodash/orderBy'
import _uniqBy from 'lodash/uniqBy'
import { getFecondityStatus } from '../../libs/state'
import _findIndex from 'lodash/findIndex'

const moduleAnimal = {
    state: {
        animals: [],
        culled: [],
        bulls: [],
        inseminations: [],
        milkResults: [],
        cattleLoading: false,
        bullLoading: false,
        culledLoading: false,
        sicknessList: [],
        tableOrder: {
            columns: [],
            orders: []
        },
        filterTypes: ['cow', 'heifer', 'calf', 'bull'],
        filterCowTypes: ['cow', 'heifer'],
        filtreBullTypes: ['calf', 'bull'],
        filterStates: [
            'nothing',
            'calved',
            'monitor',
            'inseminate',
            'ultrasound',
            'inseminated',
            'non-inseminated',
            'to-dry-up',
            'dried'
        ],
        filterCulled: [],
        filterBull: [],
    },
    mutations: {
        resetAnimals: function(state) {
            state.animals = []
            state.culled = []
            state.bulls = []
        },
        addAnimals: function(state, animals) {
            state.animals = []
            _each(animals, function(a) {
                state.animals.push(getFecondityStatus(a))
            })
        },
        resetAnimal: function(state) {
            state.animals = []
        },
        addAnimalsPart: function(state, animals) {
            _each(animals, function(a) {
                state.animals.push(getFecondityStatus(a))
            })
        },
        addAnimal: function(state, a) {
            state.animals.push(getFecondityStatus(a))
        },
        updateAnimal: function(state, a) {
            const index = _findIndex(state.animals, {
                id: a.id
            })
            if (state.animals[index].building === a.building) {
                state.animals.splice(index, 1, getFecondityStatus(a))
            } else {
                state.animals.splice(index, 1)
            }

        },
        removeAnimal: (state, animalId) => {
            const index = _findIndex(state.animals, { id: animalId })
            state.animals.splice(index, 1)
        },
        addCulled: (state, culled) => {
            state.culled = []
            state.culled = culled
            state.filterCulled = _map(_uniqBy(culled, 'culledReason'), 'culledReason')
        },
        addBulls: (state, bulls) => {
            state.bulls = []
            state.bulls = bulls
        },
        addBull: function(state, b) {
            state.bulls.push(b)
        },
        updateBull: function(state, b) {
            const index = _findIndex(state.bulls, {
                id: b.id
            })
            state.bulls.splice(index, 1, b)
        },
        removeBull: (state, animalId) => {
            const index = _findIndex(state.bulls, { id: animalId })
            state.bulls.splice(index, 1)
        },
        toogleCattleLoading: function(state, isLoading) {
            state.cattleLoading = isLoading
        },
        toogleBullLoading: function(state, isLoading) {
            state.bullLoading = isLoading
        },
        toogleCulledLoading: function(state, isLoading) {
            state.culledLoading = isLoading
        },
        updateTableOrder(state, column) {
            let index = state.tableOrder.columns.indexOf(column)
            if (index > -1) {
                if (state.tableOrder.orders[index] === 'asc') {
                    state.tableOrder.orders.splice(index, 1, 'desc')
                } else {
                    state.tableOrder.columns.splice(index, 1)
                    state.tableOrder.orders.splice(index, 1)
                }
            } else {
                state.tableOrder.columns.push(column)
                state.tableOrder.orders.push('asc')
            }
        },
        resetTableOrder(state) {
            state.tableOrder = {
                columns: [],
                orders: []
            }
        },
        updateFilterType(state, t) {
            if (state.filterTypes.length === 4) {
                state.filterTypes = [t]
            } else if (state.filterTypes.indexOf(t) >= 0) {
                state.filterTypes.splice(state.filterTypes.indexOf(t), 1)
            } else {
                state.filterTypes.push(t)
            }
        },
        updateBullFilterType(state, t) {
            if (state.filterBull.length === 2) {
                state.filterBull = [t]
            } else if (state.filterBull.indexOf(t) >= 0) {
                state.filterBull.splice(state.filterBull.indexOf(t), 1)
            } else {
                state.filterBull.push(t)
            }
        },
        resetFilterType(state) {
            state.filterTypes = ['cow', 'heifer', 'calf', 'bull']
        },
        updateFilterCowType(state, t) {
            if (state.filterCowTypes.length === 2) {
                state.filterCowTypes = [t]
            } else if (state.filterCowTypes.indexOf(t) >= 0) {
                state.filterCowTypes.splice(state.filterCowTypes.indexOf(t), 1)
            } else {
                state.filterCowTypes.push(t)
            }
        },
        resetFilterCowType(state) {
            state.filterCowTypes = ['cow', 'heifer']
        },
        updateFilterState(state, s) {
            if (state.filterStates.length === 9) {
                state.filterStates = [s]
            } else if (state.filterStates.indexOf(s) >= 0) {
                state.filterStates.splice(state.filterStates.indexOf(s), 1)
            } else {
                state.filterStates.push(s)
            }
        },
        resetFilterState(state) {
            state.filterStates = [
                'nothing',
                'calved',
                'monitor',
                'inseminate',
                'ultrasound',
                'inseminated',
                'non-inseminated',
                'to-dry-up',
                'dried'
            ]
        },
        updateFilterCulled(state, s) {
            if (state.filterCulled.length === _uniqBy(state.culled, 'culledReason').length) {
                state.filterCulled = [s]
            } else if (state.filterCulled.indexOf(s) >= 0) {
                state.filterCulled.splice(state.filterCulled.indexOf(s), 1)
            } else {
                state.filterCulled.push(s)
            }
        },
        resetFilterCulled(state) {
            state.filterCulled = ['cull', 'sold', 'dead', 'stillbirth-dead', 'abortion-dead']
        },
        addSicknessList(state, list) {
            state.sicknessList = []
            state.sicknessList = list
        },
        addMilkResultToAnimals(state, milkResults) {
            const updatedAnimals = state.animals
            _each(milkResults, function(mr) {
                let index = _findIndex(updatedAnimals, { id: mr.animal })
                if (updatedAnimals[index] !== undefined) {
                    updatedAnimals[index].milkResults.unshift(mr)
                }
            })
            state.animals = updatedAnimals
        },
    },
    actions: {
        // fetchAnimals: function(context) {
        //     context.commit('toogleCattleLoading', true)
        //     context.commit('resetAnimals')
        //     let portion = Math.ceil(context.rootGetters.selectedFarm.animals / 200)
        //     let i
        //     for (i = 1; i <= portion; i++) {
        //         let p = i
        //         setTimeout(function() {
        //             context.dispatch('fetchAnimalsPortion', p)
        //         }, 1000 * p)
        //     }
        //     setTimeout(function() {
        //         context.commit('toogleCattleLoading', false)
        //     }, 1000 * portion)
        // },
        fetchAnimals(context) {
            context.commit('toogleCattleLoading', true)
            let count = null
            $axios.get('/api/animal/count/' + context.rootState.farm.selectedFarm).then(response => {
                count = response.data
            }).then(() => {
                let countCeil = Math.ceil(count/100)
                context.commit('resetAnimal')
                let promises = []
                for (let i = 0; i < countCeil; i++ ) {
                    let first = (100*i)
                    promises.push(
                        $axios.get('/api/animal/fetch/part/' + first + '/' + context.rootState.farm.selectedFarm)
                            .then(response => {
                                context.commit('addAnimalsPart', response.data)
                            })
                    )
                }

                Promise.all(promises).then(() => {
                    context.commit('toogleCattleLoading', false)
                })
            })
        },
        fetchCalf: function(context, param) {
            $axios
                .get('/api/animal/fetchOne/' + context.rootState.farm.selectedFarm + '?B=' + param)
                .then(response => {
                    context.commit('addAnimal', response.data)
                })
        },
        fetchCulled: function(context) {
            context.commit('toogleCulledLoading', true)
            $axios
                .get('/api/animal/culled/' + context.rootState.farm.selectedFarm)
                .then(response => {
                    context.commit('addCulled', response.data)
                })
                .then(() => {
                    context.commit('toogleCulledLoading', false)
                })
        },
        fetchBulls: function(context) {
            context.commit('toogleBullLoading', true)
            $axios
                .get('/api/bull/' + context.rootState.farm.selectedFarm)
                .then(response => {
                    context.commit('addBulls', response.data)
                })
                .then(() => {
                    context.commit('toogleBullLoading', false)
                })
        },
        fetchAnimalsPortion: function(context, portion) {
            $axios
                .get('/api/animal/fetch/' + context.rootState.farm.selectedFarm + '/' + portion)
                .then(response => {
                    context.commit('addAnimals', response.data)
                })
        },
        fetchSicknessList: function(context) {
            $axios
                .get('/api/sickness/fetch/list')
                .then(response => {
                    context.commit('addSicknessList', response.data)
                })
        },
        createAnimal: function(context, animal) {
            $axios
                .post('/api/animal/create', animal)
                .then(response => {
                    context.commit('addAnimal', response.data)
                })
        },
        editAnimal: function(context, animal) {
            $axios
                .post(
                    '/api/animal/edit/' + animal.id,
                    animal
                )
                .then(response => {
                    context.commit('updateAnimal', response.data)
                })
        },
        moveAnimal: function (context, animal) {
            context.commit('toogleFarmLoading')
            $axios.post('/api/animal/move/' + animal.id, animal).then(response => {
                context.commit('removeAnimal', animal.id)
                context.commit('toogleFarmLoading')
            })
        },
        editAnimalSicknesses: function (context, params) {
            $axios.post('/api/sickness/edit/' + params.animal.id, params)
                .then(response => {
                    context.commit('updateAnimal', response.data)
                })
        },
        createBull: function(context, bull) {
            $axios
                .post('/api/bull/create/', bull)
                .then(response => {
                    context.commit('addBull', response.data)
                })
        },
        editBull: function(context, animal) {
            $axios
                .post(
                    '/api/bull/edit/' + animal.id,
                    animal
                )
                .then(response => {
                    context.commit('updateBull', response.data)
                })
        },
        deleteAnimal: function(context, animal) {
            context.commit('toogleFarmLoading')
            $axios.get('/api/animal/delete/' + animal.id).then(response => {
                context.commit('removeAnimal', animal.id)
                context.commit('toogleFarmLoading')
            })
        },
        deleteBull: function(context, animal) {
            context.commit('toogleFarmLoading')
            $axios.get('/api/animal/delete/' + animal.id).then(response => {
                context.commit('removeBull', animal.id)
                context.commit('toogleFarmLoading')
            })
        },
        createState: function(context, params) {
            $axios
                .post(
                    '/api/state/create/' +
                        context.rootState.farm.selectedFarm +
                        '/' +
                        params[0] +
                        '/' +
                        params[1],
                    params[2]
                )
                .then(response => {
                    params
                    if (params[1] === 'calving') {
                        context.commit('updateAnimal', response.data)
                        context.dispatch('fetchCalf', params[2].buckleNumber)
                    } else if (
                        params[1] === 'cull' &&
                        (params[2].tag === 'dead' || params[2].tag === 'sold')
                    ) {
                        context.commit('removeAnimal', response.data.id)
                    } else {
                        context.commit('updateAnimal', response.data)
                    }
                })
        },
        deleteState: function(context, stateId) {
            return $axios.get('/api/state/delete/' + stateId).then(response => {
                context.commit('updateAnimal', response.data)
                return response.data
            })
        },
        commitMilkInspection(context, inspection) {
            return $axios
                .post(
                    '/api/milkinspection/commit/' + context.rootState.farm.selectedFarm,
                    inspection
                )
                .then(response => {
                    return response.data
                })
        }
    },
    getters: {
        animals: state => state.animals,
        culled: state => state.culled,
        bulls: state => state.bulls,
        cattleLoading: state => state.cattleLoading,
        bullLoading: state => state.bullLoading,
        culledLoading: state => state.culledLoading,
        sicknessList: state => state.sicknessList,
        filteredFarmAnimals: state => {
            if (state.animals.length > 0) {
                return _orderBy(
                    _filter(state.animals, function(a) {
                        return _includes(state.filterCowTypes, a.type)
                    }),
                    state.tableOrder.columns,
                    state.tableOrder.orders
                )
            } else {
                return []
            }
        },
        filteredFecondityAnimals: state => {
            if (state.animals.length > 0) {
                return _orderBy(
                    _filter(state.animals, function(a) {
                        return (
                            _includes(state.filterCowTypes, a.type) &&
                            _includes(state.filterStates, a.fecondity.state)
                        )
                    }),
                    state.tableOrder.columns,
                    state.tableOrder.orders
                )
            } else {
                return []
            }
        },
        filteredMilkInspectionAnimals: state => {
            return _orderBy(
                _filter(state.animals, function(a) {
                    return a.type === 'cow' && _includes(state.filterStates, a.fecondity.state)
                }),
                state.tableOrder.columns,
                state.tableOrder.orders
            )
        },
        filteredCulledAnimals: state => {
            return _orderBy(_filter(state.culled, function(a) {
                    return (
                        _includes(state.filterTypes, a.type) &&
                        _includes(state.filterCulled, a.culledReason)
                    )
                }),
                state.tableOrder.columns,
                state.tableOrder.orders
            )
        },
        filteredBullAnimals: state => {
            return _orderBy(_filter(state.bulls, function(a) {
                    return (
                        _includes(state.filtreBullTypes, a.type)
                    )
                }),
                state.tableOrder.columns,
                state.tableOrder.orders
            )
        },
        farmAnimalType: state => _uniq(_map(state.animals, 'type')),
        farmCulledType: state => _uniq(_map(state.culled, 'type')),
        countAnimalByType: state => params =>
            _countBy(state.animals, function(a) {
                return a.type === params
            })['true'],
        countCulledByType: state => params =>
            _countBy(state.culled, function(a) {
                return a.type === params
            })['true'],
        countBullsByType: state => params =>
            _countBy(state.bulls, function(a) {
                return a.type === params
            })['true'],
        countCulledByParam: state => params =>
            _countBy(state.culled, function(a) {
                return a.culledReason === params
            })['true'],
        countAnimalByBuilding: state => params => {
            let count = _countBy(state.animals, function(a) {
                return a.building === params
            })['true']
            return count === undefined ? 0 : count
        },
        countAnimalByFecondity: state => params => {
            return _countBy(state.animals, function(a) {
                return a.fecondity.state === params && _includes(state.filterCowTypes, a.type)
            })['true']
        },
        countCulledAnimal: state => params => {
            let count = _countBy(state.culled, function(a) {
                return true
            })['true']
            return count === undefined ? 0 : count
        },
        filterCowTypes: state => state.filterCowTypes,
        filterBullTypes: state => state.filtreBullTypes,
        filterTypes: state => state.filterTypes,
        filterStates: state => state.filterStates,
        filterCulled: state => state.filterCulled,
        filterBull: state => state.filterBull,
        filteredFarmAnimalsByType: state => params =>
            _filter(state.animals, function(a) {
                return a.type === params
            }),
        isBuckleNumberAlreadyGiven: state => params => {
            return _some({...state.animals, ...state.bulls, ...state.culled}, { buckleNumber: params })
        },
        isColumnOrdered: state => column => {
            let index = state.tableOrder.columns.indexOf(column)
            if (index > -1) {
                return state.tableOrder.orders[index] === 'asc' ? 'sort-up' : 'sort-down'
            } else {
                return 'sort'
            }
        }
    }
}

export default moduleAnimal
